// Actions
import {
  SET_AGE_SELECTION,
  SET_AGE_VALUE,
  SET_AGE_STATE
} from "../actionTypes/age.actionTypes";

// Classes
import { AgeReducerState } from "../classes/age.classes";

const initialState = new AgeReducerState();

export const AgeReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_AGE_SELECTION:
      return { ...state, selection: action.payload };
    case SET_AGE_VALUE:
      return { ...state, value: action.payload };
    case SET_AGE_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
